import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcVisibilityoff(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.339 4.722a.75.75 0 0 0-1.061-1.06L3.661 20.277a.75.75 0 1 0 1.06 1.06l3.46-3.459c1.223.44 2.524.683 3.819.683 4.275 0 8.616-2.663 10.012-6.21a2.24 2.24 0 0 0 0-1.64c-.562-1.43-1.602-2.715-2.923-3.74zm-3.32 3.32-2.02 2.019a4.25 4.25 0 0 1-5.44 5.44l-1.187 1.188a9.7 9.7 0 0 0 2.628.373c3.768 0 7.483-2.38 8.616-5.26a.74.74 0 0 0 0-.542c-.475-1.206-1.403-2.325-2.598-3.218",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.965 5.237A11.4 11.4 0 0 0 12 4.5c-4.276 0-8.616 2.663-10.012 6.211a2.24 2.24 0 0 0 0 1.64c.578 1.47 1.661 2.788 3.036 3.827l1.073-1.073c-1.25-.906-2.224-2.058-2.714-3.303a.74.74 0 0 1 0-.542C4.517 8.381 8.232 6 12 6c.944 0 1.885.15 2.784.42z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.63 7.573a4.25 4.25 0 0 0-5.556 5.556l1.208-1.208a2.75 2.75 0 0 1 3.139-3.139z"
  }));
}
var IcVisibilityoff = createNolIcon(/*#__PURE__*/forwardRef(SvgIcVisibilityoff));

export { IcVisibilityoff as I };
